import betslip from "./betslip";
import config from "./config";
import list from "./list";
import protest from "./protest";
import racing from "./racing";
import sport from "./sport";
const tradingModule = {
  namespaced: true,
  modules: {
    list,
    betslip,
    racing,
    config,
    protest,
    sport,
  },
};

export default tradingModule;
